export const ADMIN_NOTE_TYPES = {
    customer: 'customer',
    caterer: 'caterer'
}